import React from "react";
import {Col, Row} from "react-bootstrap";
import {SiJava, SiSpringboot, SiDocker, SiKubernetes, SiPostgresql, SiCouchbase, SiReact, SiAndroid, SiJavascript, SiKotlin} from "react-icons/si";

function Techstack() {
  return (
      <div>
      <h1 className="project-heading">
        <span className="purple">Technologies</span> I have worked with
      </h1>
    <Row style={{ justifyContent: "center", paddingBottom: "30px", paddingTop: 50, color: "white"}}>
      <Col xs={4} md={2} className="tech-icons">
        <SiSpringboot />
        <p style={{fontSize: 20}}>Spring Boot</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiJava />
        <p style={{fontSize: 20}}>Java</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiDocker />
        <p style={{fontSize: 20}}>Docker</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiKubernetes />
        <p style={{fontSize: 20}}>Kubernetes</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostgresql />
        <p style={{fontSize: 20}}>Postgresql</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiCouchbase />
        <p style={{fontSize: 20}}>Couchbase</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiReact />
        <p style={{fontSize: 20}}>React</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiAndroid />
        <p style={{fontSize: 20}}>Android</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiJavascript />
        <p style={{fontSize: 20}}>Javascript</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiKotlin />
        <p style={{fontSize: 20}}>Kotlin</p>
      </Col>
    </Row>
      </div>
  );
}

export default Techstack;
